export default __webpack_public_path__ + "static/media/logo_ncentiva_db.fcb503c1.svg";